<div class="circuit-stats-container">
  @for (item of circuitCounts(); track item.name) {
    <div
      class="stat-row"
      [attr.data-circuit-name]="item.name"
      [class.is-hover-match]="isRowMatching(item.gates)"
      [class.is-hover-dimmed]="hoverActive() && !noDim() && !isRowMatching(item.gates)"
      [class.is-stat-clickable]="isStatClickable(item.activeGates)"
      [class.is-stat-frozen]="isStatFrozen(item.key)"
      [attr.title]="isStatClickable(item.activeGates) ? statTooltip(item.key) : null"
      (click)="onStatClick(item.key, item.activeGates)"
    >
      @if (isStatFrozen(item.key)) {
        <i class="fa-solid fa-snowflake stat-freeze-icon"></i>
      }
      <span class="circuit-label" [title]="item.fullName">
        @if (item.formatGates.length > 0) {
          <i class="fa-solid fa-square-f format-icon" [title]="getFormatTooltip(item.formatGates)"></i>
        }
        <b>{{ item.name }}</b>
      </span>
      <span class="count-values">
        @if (selectedSide() === null) {
          <span class="count-value">{{ item.count }}x</span>
        } @else {
          @if (item.count !== item.selectedCount) {
            <span class="count-value count-value--overall" aria-hidden="true">{{ item.count }}x</span>
          }
          <span class="count-value count-value--selected" [style.color]="selectedColor()">
            {{ item.selectedCount }}x
          </span>
        }
      </span>
    </div>
  }
</div>
